import React, { FC } from 'react';
import styles from './verify_lawyer_modal_components.module.scss';

export const VerifyLawyerModalContent: FC = ({ children }) => (
  <div className={styles.content}>{children}</div>
);
